import { Component, OnInit, HostBinding, NgZone, SimpleChanges, OnChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { BreakpointObserver } from '@angular/cdk/layout';
import { DecodedToken } from '@core/models';
import { tap } from 'rxjs/operators';
import { environment } from '@environments/environment';
import { Select, Store } from '@ngxs/store';
import { UiState } from './ngxs-store/ui-store/ui.state';
import { ToggleIsInferiorBrowserAction, CloseToastrAction } from './ngxs-store/ui-store/ui.actions';
import { OverlayContainer } from '@angular/cdk/overlay';
import browser from 'browser-detect';
import { ToastrService } from 'ngx-toastr';
import { ToastrConfig, ToastrType } from '@core/models/ui/toastr-config';
import { AuthState } from '@ngxs-store/auth-store/auth.state';
import { CartState } from '@ngxs-store/cart/cart.state';
import { CartModel, WishlistModel } from '@core/services/api.service';
import { WishListState } from '@ngxs-store/wish-list-store/wish-list.state';
import { LoadCartItemsAction } from '@ngxs-store/cart/cart.actions';
import { LoadWishListAction } from '@ngxs-store/wish-list-store/wish-list.actions';
import { Router } from '@angular/router';
import { RouterExtService } from '@core/services/router-ext.service';


@Component({
    selector: 'app-root',
    animations: [],
    template: `
        <app-shared-header
            [decodedToken] ="decodedToken$ | async"
            [hasValidToken] ="hasValidToken$ | async"
            [cart] ="cart$ | async"
            [wishList] ="wishList$ | async"
        ></app-shared-header>
        <router-outlet></router-outlet>
        <app-shared-footer></app-shared-footer>
  `,
    styles: []
})
export class AppComponent implements OnInit, OnChanges {
    @Select(UiState.getToastrConfig) toastrConfig$: Observable<ToastrConfig>;
    @Select(CartState.Cart) cart$: Observable<CartModel>;
    @Select(WishListState.getItems) wishList$: Observable<WishlistModel>;
    @Select(AuthState.getDecodedToken) decodedToken$: Observable<DecodedToken>;
    @Select(AuthState.getHasValidToken) hasValidToken$: Observable<boolean>;
    @HostBinding('class') componentCssClass: any;
    private toast: ToastrType;

    constructor(
        private store: Store,
        private zone: NgZone,
        public overlayContainer: OverlayContainer,
        private breakpointObserver: BreakpointObserver,
        public toastr: ToastrService,
        private router: Router,
        public routerExtService: RouterExtService,

    ) {
        if (this.store.selectSnapshot(AuthState.getHasValidToken)) {
            this.store.dispatch([
                new LoadCartItemsAction(),
                new LoadWishListAction()
            ]);
        }
    }

    ngOnInit() {
        this.initInferiorBrowser();
        this.initToasterSubscription();
    }

    ngOnChanges(changes: SimpleChanges) {

        if (changes.toastrConfig && !changes.toastrConfig.firstChange) {

            this.initToasterSubscription();
        }

    }

    initInferiorBrowser() {
        this.store.dispatch(
            new ToggleIsInferiorBrowserAction({
                isInferiorBrowser: environment.inferiorBrowsers.includes(browser().name)
            })
        );
    }

    initToasterSubscription() {
        let toasterRef: any;
        this.toastrConfig$
            .pipe(
                tap((toastrConfig) => {
                    if (toastrConfig && toastrConfig.show) {


                        switch (toastrConfig.type) {
                            case ToastrType.warning:
                                toasterRef = this.toastr.warning(toastrConfig.message);
                                toasterRef.onAction.subscribe(() => {
                                    this.store.dispatch(new CloseToastrAction());
                                });
                                break;
                            case ToastrType.error:
                                toasterRef = this.toastr.error(toastrConfig.message);
                                toasterRef.onAction.subscribe(() => {
                                    this.store.dispatch(new CloseToastrAction());
                                });
                                break;
                            case ToastrType.success:
                                toasterRef = this.toastr.success(toastrConfig.message);
                                toasterRef.onAction.subscribe(() => {
                                    this.store.dispatch(new CloseToastrAction());
                                });
                                break;
                        }

                    }
                })
            )
            .subscribe();
    }

}
